const PCORE_EVENT = {
	'READY': 'ready',

	'BUFFER': 'buffer',

	'BUFFERING': 'buffering',//:NOTE:: same as previous, for some reason jw refers to both

	'PAUSE': 'pause',

	'PLAY': 'play',

	'PLAYING': 'playing', //:NOTE:: same as previous, for some reason jw refers to both

	'IDLE': 'idle',

	'FULL_SCREEN': 'fullscreen',

	'VOLUME_CHANGE': 'volume',

	'MUTE': 'mute',

	'BEFORE_PLAY': 'beforePlay',

	'BEFORE_COMPLETE': 'beforeComplete',

	'COMPLETE': 'complete',

	'SETUP_ERROR': 'setupError',

	'ERROR': 'error',

	'META_AVAILABLE': 'meta',

	'TIME_UPDATE': 'time',

	'SEEK_INIT': 'seek',

	'SEEK_COMPLETE': 'seeked',

	'FIRST_FRAME': 'firstFrame',

	'STAGE_RESIZE': 'resize',

	'BUFFER_CHANGE': 'bufferChange',

	'BUFFER_FULL': 'bufferFull',

	'CAST_ACTIVE': 'cast',

	'DISPLAY_CLICK': 'displayClick',

	'CONTROLS_PRESENT': 'controls',

	'QUALITY_CHANGE': 'qualityChange',

	'QUALITY_LEVELS': 'qualityLevels',

	'CAPTIONS_LIST': 'captionsList',

	'CAPTIONS_CHANGE': 'captionsChange',

	'PLAYLIST_ITEM': 'playlistItem',

	'CLOSE_PLAYER': 'closePlayer',

	'INIT_SETUP': 'setup',

	'TOGGLE_LOCK': 'toggle_lock',

	'SURVEY_NOTIFICATION': 'survey_notificaiton',

	'TUNEOUT': 'TUNEOUT',

	'START': 'start',
	'UPDATE': 'update',


	// INTERACTIVE_EVENTS
	'POST_ANSWER': 'post_answer',
	'POST_SCENE': 'scene_response',
	'DISPLAY_QUESTION': 'display_question',
	'DISPLAY_SURVEY': 'DISPLAY_SURVEY',
	'DISPLAY_PREROLL': 'display_preroll',
	'SURVEY_COMPLETE': 'survey_complete',
	'PANEL_READY': 'panel_ready',
	'METHOD_CALL': 'method_call',
	'DISPLAY_TUNEOUT_QUESTIONS': 'display_tuneout_questions',
	'MAXDIFF_VERSION_REQUEST': 'maxdiff_version_request',
	'MAXDIFF_VERSION_RESPONSE': 'maxdiff_version_response',
	'FOLLOW_UP_REQUEST': 'follow_up_request',
	'FOLLOW_UP_RESPONSE': 'follow_up_response',

	'TERMINATE': 'TERMINATE',
	'BAD_RESPONDANT' : 'BAD_RESPONDANT',
	'FINAL_SUBMISSION_FAIL' : 'FINAL_SUBMISSION_FAIL',
	'QUESTION_SET_COMPLETE': 'QUESTION_SET_COMPLETE',
	'QUESTION_SET_START': 'QUESTION_SET_START',
	'INFO': 'info',
	'TIME_UPDATE_STATE': 'time_update'
};

export default PCORE_EVENT;


// WEBPACK FOOTER //
// ./src/constants/pilotly-player/index.js